import React from "react";
import AppRouter from "./router";
import "antd/dist/antd.css";

function App() {
  return (
    <>
      <AppRouter />
    </>
  );
}

export default App;
